import { getRequiredRemotePropertiesModelUtil } from 'models/utils/get-required-remote-properties'
import {
  isPlainObjectUtil,
  mapValuesObjectUtil
} from 'packages/src'

function getUpdatedDataReduxUtil (instance) {
  if (!instance) {
    return
  }

  const { data } = instance
  let { changed } = instance
  changed = mapValuesObjectUtil(changed, (value, key) => {
    // It's an object,
    // save the whole object with the changed attributes
    if (isPlainObjectUtil(value)) {
      return {
        ...data[key],
        ...value
      }
    }
    return value
  })

  return {
    ...getRequiredRemotePropertiesModelUtil(data),
    ...changed
  }
}

export {
  getUpdatedDataReduxUtil
}
